import { baseApi } from 'segments/api/baseApi';

import { adapteWaitingList } from '../utils/adapter';

import type {
  CreateBookingWaitInfoParams,
  EditBookingWaitInfoParams,
  BookingWaitList,
} from './types';

export const api = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWaitingList: builder.query<BookingWaitList, string>({
      query: (date) => ({
        url: '/admin/waiting_list/get',
        method: 'GET',
        params: {
          'date': date,
        }
      }),
      transformResponse: adapteWaitingList,
      providesTags: ['WaitingList'],
      keepUnusedDataFor: 1,
    }),
    createBookingWait: builder.mutation<void, CreateBookingWaitInfoParams>({
      query: (data) => ({
        url: '/admin/waiting_list/create',
        method: 'POST',
        body: {
          note: data.note,
          'user_id': data.userId,
          'end_time': data.endTime,
          'start_time': data.startTime
        },
      }),
      invalidatesTags: ['WaitingList'],
    }),
    updateBookingWait: builder.mutation<void, EditBookingWaitInfoParams>({
      query: ({ id, ...data }) => ({
        url: `/admin/waiting_list/update/${id}`,
        method: 'PUT',
        body: {
          note: data.note,
          'end_time': data.endTime,
          'start_time': data.startTime
        },
      }),
      invalidatesTags: ['WaitingList'],
    }),
    deleteBookingWait: builder.mutation<void, number>({
      query: (id) => ({
        url: `/admin/waiting_list/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['WaitingList'],
    }),
  }),
});

export const {
  useCreateBookingWaitMutation,
  useDeleteBookingWaitMutation,
  useGetWaitingListQuery,
  useUpdateBookingWaitMutation,
} = api;
